import React from "react";

interface Props {
  title: string;
  uid: any;
}

const FooterColumnHead: React.FC<Props> = (props: Props) => {
  const { title } = props;
  return (
    <div data-test-footer className="footer-head">
      <span className="float-xs-start">{title} </span>
      <span className="float-end d-xl-none"></span>
    </div>
  );
};

export default FooterColumnHead;
